export default __webpack_public_path__ + "static/media/bg1.9167092d.jpg";